const ES = {
    title: 'Links de Pago',
    subtitle: 'Link de Pago', /* se usa en submenu link de pago en detalles de cliente */
    table: {
        title: 'Listado de Links de Pago',
        columns: {
            linkNumber: 'N° Link',
            client: 'Vendedor',
            dni: 'INE',
            description: 'Descripción',
            amount: 'Monto',
            createdAt: 'Fecha Creación',
            paymentDate: 'Último intento de pago',
            status: 'Estado',
            paymentLinkPosition: 'Posición link de pago'
        },
        filter: {
            0: {
                0: 'Pendiente',
                1: 'Confirmado',
                2: 'Rechazado',
                3: 'Vencido',
                title: 'Estado'
            },
            1: {
                0: 'Diamante',
                1: 'Zafiro',
                2: 'Oro',
                3: 'Plata',
                4: 'Bronce',
                title: 'Nivel'
            },
        },

    }
};

export default ES;
